/*
  CB 15/10/2026 - Carrello laterale Vitals su MOBILE (fino a 768px).
  1) Parte inferiore (codice sconto, sconti e risparmi con subtotale, garanzia
     legale, "Continua lo shopping") apribile/chiudibile con la barra
     "Codice sconto e riepilogo". Il pulsante "Vai al checkout" resta sempre visibile.
     Chiusa di default; la scelta resta per la visita (sessionStorage).
     Non sposta nulla del markup di Vitals: aggiunge la barra e due classi su <html>
     (cb-fold-on = funzione attiva, cb-fold--open = parte inferiore aperta).
     Stile in assets/cb-fixes-1510b.css.
  2) Blocco della pagina dietro il carrello. Vitals blocca la pagina con
     "overflow: hidden" su html/body, che Safari su iPhone ignora: col dito si
     scorreva la pagina sotto il carrello all'infinito. Finche' il carrello e' aperto
     (classe Vitals vtl-window-no-scroll su <html>) il body resta fissato nella
     posizione in cui si trovava; alla chiusura si torna allo stesso punto.
     Contenitore fermo e scorrimento solo dentro lista / parte inferiore:
     assets/cb-fixes-1510c.css (blocco 13).
*/
(function () {
  var DRAWER = '#vitals-cart_drawer-container .Vtl-CartDrawer__Container'
  var CHECKOUT = '.Vtl-CartDrawerCheckout'
  var KEY = 'cbCartFoldOpen'
  var mq = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null
  var CHEV =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'
  var open = false
  try { open = sessionStorage.getItem(KEY) === '1' } catch (e) {}

  function isMobile() { return !!(mq && mq.matches) }

  // ---- blocco pagina (iPhone) ----------------------------------------------
  var locked = false
  var savedY = 0
  function lockSync() {
    var want = isMobile() &&
      document.documentElement.classList.contains('vtl-window-no-scroll') &&
      !!document.querySelector(DRAWER)
    var s = document.body.style
    if (want && !locked) {
      savedY = window.scrollY || window.pageYOffset || 0
      s.position = 'fixed'
      s.top = -savedY + 'px'
      s.left = '0'
      s.right = '0'
      s.width = '100%'
      document.documentElement.classList.add('cb-body-locked')
      locked = true
    } else if (!want && locked) {
      s.position = ''
      s.top = ''
      s.left = ''
      s.right = ''
      s.width = ''
      document.documentElement.classList.remove('cb-body-locked')
      locked = false
      try { window.scrollTo({ top: savedY, left: 0, behavior: 'instant' }) } catch (e) { window.scrollTo(0, savedY) }
    }
  }

  function apply() {
    var root = document.documentElement
    var box = document.querySelector(DRAWER)
    var co = box && box.querySelector(CHECKOUT)
    var on = !!co && isMobile()
    root.classList.toggle('cb-fold-on', on)
    root.classList.toggle('cb-fold--open', on && open)
    lockSync()
    if (!co) return
    var btn = co.querySelector(':scope > .cb-fold__toggle')
    if (!on) { if (btn) btn.remove(); return }
    if (!btn) {
      btn = document.createElement('button')
      btn.type = 'button'
      btn.className = 'cb-fold__toggle'
      btn.innerHTML = '<span>Codice sconto e riepilogo</span>' + CHEV
      co.insertBefore(btn, co.firstChild)
    } else if (co.firstChild !== btn) {
      co.insertBefore(btn, co.firstChild)
    }
    btn.setAttribute('aria-expanded', open ? 'true' : 'false')
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.cb-fold__toggle') : null
    if (!b) return
    e.preventDefault()
    e.stopPropagation()
    open = !open
    try { sessionStorage.setItem(KEY, open ? '1' : '0') } catch (err) {}
    apply()
  }, true)

  var pending = false
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target
      if (t && t.closest && t.closest('.cb-fold__toggle')) continue
      if (pending) return
      pending = true
      requestAnimationFrame(function () {
        pending = false
        apply()
      })
      return
    }
  }).observe(document.body, { childList: true, subtree: true })

  // apertura/chiusura del carrello: Vitals cambia le classi di <html>
  new MutationObserver(lockSync).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })

  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', apply)
    else if (mq.addListener) mq.addListener(apply)
  }
})()